define('Store.Transaction.Line.Views.Price.View', [
    'Transaction.Line.Views.Price.View',
    'underscore'
], function StoreTransactionLineViewsPriceView(
    TransactionLineViewsPriceView,
    _
) {
    'use strict';

    _.extend(TransactionLineViewsPriceView.prototype, {
        getContext: _.wrap(TransactionLineViewsPriceView.prototype.getContext, function getContext(fn) {
            var ret = fn.apply(this, _.toArray(arguments).slice(1));
            var priceContainerObject = this.model.getPrice();
            ret.isCart = this.attributes && this.attributes['data-root-component-id'] === 'Cart.Detailed.View';
            ret.showComparePrice = (this.options.showComparePrice ||
                (this.parentView && this.parentView.attributes && this.parentView.attributes.id === 'Cart.Confirmation.View')) &&
                priceContainerObject.price < priceContainerObject.compare_price;
            return ret;
        })
    });
});
